// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c5b15cc3","732":"4a01735c","977":"a6392b47"}[chunkId] + ".chunk.js";
};